import { FC } from 'react';

import { PadlockIcon } from '../../icons';
import type { IconSize } from '../../icons/svgToIconElement';

import { ImageOverlayWrapper } from './ImageOverlayWrapper';
import { programStateFallbackLabel } from './programStateLabel';

import styles from './OverlayIcon.module.css';

interface Props {
  iconSize?: IconSize;
  label?: string;
  /**
   * Overrides `iconSize` when set
   */
  iconHeight?: number;
}
export const PadlockOverlay: FC<Props> = ({ iconSize = 'large', iconHeight, label }) => {
  const ariaLabel = label ? label : programStateFallbackLabel.noAccess;
  const size = iconHeight ? { height: `${iconHeight}px`, width: 'auto' } : {};
  return (
    <ImageOverlayWrapper label={label} aria-label={ariaLabel} centerContent backdropStyle="dark">
      <PadlockIcon
        className={styles.overlayIcon}
        iconSize={iconSize}
        style={{ marginBottom: '.5rem', color: 'var(--rds-foreground-primary)', ...size }}
      />
    </ImageOverlayWrapper>
  );
};
